// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import PopupHost from "./components/common/PopupHost";
import "./polyfills/dateDisplayPatch";
import "./i18n";
import "./index.css";
import { UserProvider } from "./context/UserContext";
import { RegionalSettingsProvider } from "./context/RegionalSettingsContext";
import { ReportSettingsProvider } from "./context/ReportSettingsContext";
import "react-datepicker/dist/react-datepicker.css";
import { installPopupOverrides } from "./utils/popup";

// sockjs-client expects `global` in some bundlers
if (typeof window !== "undefined" && typeof window.global === "undefined") {
  window.global = window;
}

installPopupOverrides();

window.addEventListener("storage", (e) => {
  if (e.key === "force-logout") {
    // Make sure every tab clears everything
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("activeRole");
    localStorage.removeItem("roles");
    // Optional: force navigation if this tab is on a protected route
    if (window.location.pathname !== "/login") {
      window.location.replace("/login");
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <UserProvider>
      <RegionalSettingsProvider>
        <ReportSettingsProvider>
          <App />
          <PopupHost />
        </ReportSettingsProvider>
      </RegionalSettingsProvider>
    </UserProvider>
  </React.StrictMode>,
);
